export enum HotjarIdentifier {
  GlobalSearch = 'global_search',
  WeeklyTimeTracking = 'weekly_time_tracking',
  SearchModule = 'search_module',
  SegmentAdded = 'segment_added',
  TimeTracker = 'time_tracker',
  CustomerMeetingRoom = 'customerMeetingRoom',
  CompanyEntity = 'companyEntity2',
  ContactsImport = 'contacts_import',
  ContactsExport = 'contacts_export',
  CompaniesImport = 'companies_import',
  CompaniesExport = 'companies_export',
}

export enum HotjarTag {
  GlobalSearch = 'global_search',
  WeeklyTimeTracking = 'weekly_time_tracking',
}
